export const moduleId = 'enterprises';
